// require("jquery");
import "core-js/stable";
import "regenerator-runtime/runtime";
import "@hotwired/turbo-rails"
import "bootstrap"

require("./Difacto");
require("./Admin");
require("./Publisher");

import './stylesheets/application.scss'
